import React from "react";
import { Text } from "@jasperlabs/ui";
import { useFeatureFlag } from "@/components/utilities/featureFlag";
import { formatFullName } from "@/components/utilities/stringFormat";
import {
	AccountDataDocument,
	SessionDataDocument,
} from "./operations.generated";
import { useQuery } from "@apollo/client/react";

const ImpersonationBanner = () => {
	const { data: accountData = null } = useQuery(AccountDataDocument, {
		fetchPolicy: "cache-and-network",
	});

	const { data: sessionData = null } = useQuery(SessionDataDocument, {
		fetchPolicy: "cache-and-network",
	});

	const { account = null } = accountData || {};
	const { session = null } = sessionData || {};
	const { impersonatedBy = null } = session || {};

	const isDisableImpersonationBannerEnabled = useFeatureFlag(
		"DISABLE_IMPERSONATION_BANNER",
	);

	if (!impersonatedBy || isDisableImpersonationBannerEnabled) {
		return null;
	}

	return (
		<div className="z-banner-important relative">
			<div className="bg-warning flex justify-center px-5 py-4">
				<Text variant="body-default" className="w-full text-center text-white">
					{formatFullName(account)} is being impersonated by{" "}
					{formatFullName(impersonatedBy)}
				</Text>
			</div>
		</div>
	);
};

export default ImpersonationBanner;
